import { GraphEdge } from '../GraphEdge'

export function generateTextEdges(templateField, templateFields) {
  const results = []

  const calculatedFields = templateFields.filter(tf => tf.field?.transformation?.calculated?.length)

  calculatedFields.forEach(cf => {
    cf.field?.transformation?.calculated.forEach(c => {
      results.push(new GraphEdge(c.origin_field_id, cf.field_id))
    })
  })

  return results
}
